import { TaskActionTypes } from './task.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addTaskSuccess: null,
    addTaskError: null,
    addTaskReqStatus: '',
    taskListSuccess: null,
    taskListError: null,
    taskDetailSuccess: null,
    taskDetailError: null,
    updateTaskStatusSuccess: null,
    updateTaskStatusError: null,
    updateTaskStatusReqStatus: '',
    updateTaskDetailSuccess: null,
    updateTaskDetailError: null,
    updateTaskDetailReqStatus: '',
    assignTaskSuccess: null,
    assignTaskError: null,
    assignTaskReqStatus: '',
    addTaskCommentSuccess: null,
    addTaskCommentError: null,
    addTaskCommentReqStatus: ''
}

const taskReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TaskActionTypes.ADD_TASK_REQUEST_SUCCESS:
            return {
                ...state,
                addTaskSuccess: action.payload,
                addTaskError: null,
                addTaskReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case TaskActionTypes.ADD_TASK_REQUEST_ERROR:
            return {
                ...state,
                addTaskSuccess: null,
                addTaskError: action.payload,
                addTaskReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case TaskActionTypes.ADD_TASK_REQUEST_STATUS:
            return {
                ...state,
                addTaskReqStatus: ''
            }
        case TaskActionTypes.TASK_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                taskListSuccess: action.payload,
                taskListError: null
            }
        case TaskActionTypes.TASK_LIST_REQUEST_ERROR:
            return {
                ...state,
                taskListSuccess: null,
                taskListError: action.payload
            }
        case TaskActionTypes.TASK_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                taskDetailSuccess: action.payload,
                taskDetailError: null
            }
        case TaskActionTypes.TASK_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                taskDetailSuccess: null,
                taskDetailError: action.payload
            }
        case TaskActionTypes.UPDATE_TASK_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                updateTaskStatusSuccess: action.payload,
                updateTaskStatusError: null,
                updateTaskStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case TaskActionTypes.UPDATE_TASK_STATUS_REQUEST_ERROR:
            return {
                ...state,
                updateTaskStatusSuccess: null,
                updateTaskStatusError: action.payload,
                updateTaskStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case TaskActionTypes.UPDATE_TASK_STATUS_REQUEST_STATUS:
            return {
                ...state,
                updateTaskStatusReqStatus: ''
            }
        case TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                updateTaskDetailSuccess: action.payload,
                updateTaskDetailError: null,
                updateTaskDetailReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                updateTaskDetailSuccess: null,
                updateTaskDetailError: action.payload,
                updateTaskDetailReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST_STATUS:
            return {
                ...state,
                updateTaskDetailReqStatus: ''
            }
        case TaskActionTypes.ASSIGN_TASK_REQUEST_SUCCESS:
            return {
                ...state,
                assignTaskSuccess: action.payload,
                assignTaskError: null,
                assignTaskReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case TaskActionTypes.ASSIGN_TASK_REQUEST_ERROR:
            return {
                ...state,
                assignTaskSuccess: null,
                assignTaskError: action.payload,
                assignTaskReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case TaskActionTypes.ASSIGN_TASK_REQUEST_STATUS:
            return {
                ...state,
                assignTaskReqStatus: ''
            }
        case TaskActionTypes.ADD_TASK_COMMENT_REQUEST_SUCCESS:
            return {
                ...state,
                addTaskCommentSuccess: action.payload,
                addTaskCommentError: null,
                addTaskCommentReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case TaskActionTypes.ADD_TASK_COMMENT_REQUEST_ERROR:
            return {
                ...state,
                addTaskCommentSuccess: null,
                addTaskCommentError: action.payload,
                addTaskCommentReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case TaskActionTypes.ADD_TASK_COMMENT_REQUEST_STATUS:
            return {
                ...state,
                addTaskCommentReqStatus: ''
            }
        case TaskActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default taskReducer